import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../services/firebase';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

const RecuperarSenha = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      toast.error('Digite um e-mail válido.');
      return;
    }

    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, email.trim());
      toast.success(
        'E-mail de redefinição enviado! Verifique sua caixa de entrada.'
      );
      setEmail('');
    } catch (error) {
      console.error('Erro ao enviar e-mail de redefinição:', error);

      if (error.code === 'auth/user-not-found') {
        toast.error('Usuário não encontrado.');
      } else if (error.code === 'auth/invalid-email') {
        toast.error('E-mail inválido.');
      } else {
        toast.error(
          'Erro ao enviar e-mail. Verifique o endereço e tente novamente.'
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-elion-navy text-white">
      <div className="bg-white/10 backdrop-blur-md rounded-xl shadow-lg p-8 w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6 text-center">Recuperar senha</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block mb-1 text-sm text-gray-300">E-mail</label>
            <input
              type="email"
              placeholder="seu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
              className="w-full px-4 py-2 rounded bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-elion-gold"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-elion-gold text-elion-navy font-semibold py-2 rounded-full hover:bg-yellow-400 transition hover:scale-105 disabled:opacity-60"
          >
            {loading ? 'Enviando...' : 'Enviar link de recuperação'}
          </button>
        </form>
        <div className="mt-4 text-sm text-center">
          <Link
            to="/login"
            className="text-gray-300 hover:text-white transition"
          >
            Voltar ao login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RecuperarSenha;
